export const GUEST_CONFIG = Object.freeze({
    nicknameMin: 3, nicknameMax: 20, idleTimeoutMs: 60_000, idleWarningMs: 50_000,
    cookieLifetimeSeconds: 30 * 24 * 60 * 60, challengeTtlMs: 90_000,
    proofDifficulty: 12, nameplateDistance: 35,
});
export const GUEST_SYMBOLS = ["circle", "square", "triangle"];
export function normalizeNickname(value) {
    if (typeof value !== "string" || value.length > 64)
        return undefined;
    // Trim ordinary surrounding spaces; controls and Unicode are always rejected.
    const name = value.replace(/^ +| +$/g, "");
    return /^[A-Za-z0-9_-]{3,20}$/.test(name) ? name : undefined;
}
